import { Animated } from "react-native";

export const cardStyleInterpolatorSlide = ({
	current,
	closing,
	next,
	layouts,
}) => {
	let translateX;
	let opacity;

	if (next) {
		translateX = Animated.subtract(
			0,
			Animated.multiply(layouts.screen.width, next.progress)
		);

		opacity = Animated.subtract(1, next.progress);
	} else {
		translateX = Animated.subtract(
			layouts.screen.width,
			Animated.multiply(layouts.screen.width, current.progress)
		);

		opacity = current.progress;
	}

	return {
		containerStyle: {
			opacity,
			transform: [
				{
					translateX,
				},
			],
		},
	};
};
